import { useState } from 'react';
import CustomSelect from '../common/CustomSelect';
import CustomInput from '../TransactionForm/CustomInput';
import { apiService } from '../../../client/common/apiCallService';
import { useSelector } from 'react-redux';
import TransactionCommonModal from '../common/TransactionCommonModal';
import ErrorContainer from '../TransactionForm/ErrorContainer';
import { filterBalances } from '../../../client/Juno/helpers';
import PropTypes from 'prop-types';
import ActionConfirmModal from '../common/ActionConfirmModal';
import { DeleteOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import TransactionStatus from '../TransactionStatus';
import CopyButton from '../common/CopyButton';
import { truncateMiddle } from '../../helpers/constant';

const AddNewAddress = ({
    close = () => { },
    onBottomClick = () => { },
    onBack = () => { },
    back = false,
    open = true,
    heading = 'Add New Address',
    bottomText = 'Save Address',
    getCryptoAddress,
    address,
    addressNickName,
    mode,
    addressId,
    deleteAddress,
    setParentModals,
}) => {
    const apiUrl = useSelector(state => state.config.api_url);
    const clientData = useSelector(state => state.juno.clientData);
    const { unfreezeCryptoCurrencies } = useSelector(state => state.juno);
    const updatedUnfreeze = filterBalances(unfreezeCryptoCurrencies);

    const [masterState, setMasterState] = useState({
        selectedBlockchain: updatedUnfreeze?.[0],
        nickname: addressNickName || '',
        address: address || '',
        error: '',
        loading: '',
        network: { currencyShortName: 'Ethereum' },
    });

    const [modals, setModals] = useState({
        openMainScreen: true,
        openConfirmModal: false,
        openDeleteModal: false,
    });

    const [status, setStatus] = useState({
        status: '',
        message: '',
        open: false,
    });

    const getBlockchain = () => {
        if (masterState?.selectedBlockchain?.currencyShortName == 'USDT') {
            return masterState?.network?.currencyShortName;
        }

        return masterState?.selectedBlockchain?.blockchain;
    };

    const validateWalletAddress = async () => {
        setMasterState(prev => ({ ...prev, loading: true }));

        const payload = {
            crypto: masterState?.selectedBlockchain?.currencyShortName,
            blockchain: getBlockchain(),
            walletAddress: masterState?.address,
            nickname: masterState?.nickname,
            clientId: clientData.clientId,
        };

        await apiService(
            (window.location.hostname === 'localhost' ? apiUrl : '') +
            '/restapi/validate-wallet-address',
            payload,
            async response => {
                if (response?.error) {
                    setMasterState(prev => ({
                        ...prev,
                        error: response?.message?.message || response?.message?.msg || 'Validations failed',
                    }));
                    return;
                }

                if (mode == 'edit') {
                    setModals(prev => ({
                        ...prev,
                        openConfirmModal: true,
                        openMainScreen: false,
                    }));
                } else {
                    saveNewAddress();
                }
            },
            err => {
                setMasterState(prev => ({
                    ...prev,
                    error: err.message,
                }));
            },
        );
        setMasterState(prev => ({ ...prev, loading: false }));
    };

    const saveNewAddress = async () => {
        const payload = {
            clientId: clientData.clientId,
            nickName: masterState?.nickname,
            cryptoId: masterState?.selectedBlockchain?.currencyShortName,
            blockchain: getBlockchain(),
            address: masterState?.address,
        };

        await apiService(
            (window.location.hostname === 'localhost' ? apiUrl : '') +
            '/restapi/save-crypto-address',
            payload,
            async response => {
                if (response) {
                    if (setParentModals) {
                        setParentModals({
                            openManage: false,
                        });
                    }
                    setStatus({
                        open: true,
                        status: 'success',
                        message: 'Address added successfully',
                    });
                    await getCryptoAddress();
                }
            },
            err => {
                console.log(err);
                setStatus({
                    open: true,
                    status: 'error',
                    message: 'Failed to add address',
                });
            },
        );
    };

    const updateAddress = async () => {
        setMasterState(prev => ({ ...prev, loading: true }));

        const payload = {
            clientId: clientData.clientId,
            nickName: masterState?.nickname,
            cryptoId: masterState?.selectedBlockchain?.currencyShortName,
            blockchain: getBlockchain(),
            address: masterState?.address,
            addressId,
        };

        await apiService(
            (window.location.hostname === 'localhost' ? apiUrl : '') +
            '/restapi/update-crypto-address',
            payload,
            async response => {
                if (response) {
                    setStatus({
                        open: true,
                        status: 'success',
                        message: 'Address updated successfully',
                    });
                    await getCryptoAddress();
                }
            },
            err => {
                console.log(err);
                setStatus({
                    open: true,
                    status: 'error',
                    message: 'Failed to updated address',
                });
            },
        );
        setMasterState(prev => ({ ...prev, loading: true }));
    };

    return (
        <>
            {modals.openMainScreen && !status.open ? (
                <TransactionCommonModal
                    open={open}
                    onClose={() => close()}
                    onBack={() => onBack()}
                    heading={heading}
                    bottomButtonText={mode != 'edit' ? bottomText : ''}
                    onBottomButtonClick={() => validateWalletAddress()}
                    showBackButton={back}
                    showCloseIcon={true}
                    loading={masterState.loading}
                    disabled={masterState.loading || !masterState.address || !masterState.nickname}>
                    <div className="self-stretch flex flex-col justify-start items-start gap-1">
                        <CustomSelect
                            value={masterState?.selectedBlockchain}
                            onChange={selected =>
                                setMasterState(prev => ({
                                    ...prev,
                                    selectedBlockchain: selected,
                                }))
                            }
                            label={'select crypto'}
                            options={updatedUnfreeze}
                            disabled={mode == 'edit'}
                        />
                        {masterState?.selectedBlockchain?.currencyShortName == 'USDT' ? (
                            <CustomSelect
                                value={masterState.network}
                                onChange={selected =>
                                    setMasterState(prev => ({
                                        ...prev,
                                        network: selected,
                                    }))
                                }
                                label={'select network'}
                                options={[
                                    { currencyShortName: 'Ethereum' },
                                    { currencyShortName: 'Tron' },
                                ]}
                            />
                        ) : null}
                        <CustomInput
                            label="nickname"
                            type="text"
                            name="nickname"
                            placeholder="enter address name"
                            value={masterState?.nickname}
                            onChange={({ target }) =>
                                setMasterState(prev => ({
                                    ...prev,
                                    error: '',
                                    nickname: target.value,
                                }))
                            }
                            disabled={masterState.loading}
                        />
                        <CustomInput
                            label="address"
                            type="text"
                            name="address"
                            placeholder="enter wallet address"
                            value={masterState?.address}
                            onChange={({ target }) =>
                                setMasterState(prev => ({
                                    ...prev,
                                    error: '',
                                    address: target.value,
                                }))
                            }
                            disabled={masterState.loading}
                        />
                        {masterState.error ? <ErrorContainer message={masterState.error} /> : null}
                        {mode == 'edit' ? (
                            <div className="flex w-full gap-2 mt-6">
                                <div
                                    className="w-11 p-2.5 !bg-secondary rounded-lg flex justify-center items-center gap-1 cursor-pointer"
                                    onClick={() => {
                                        setModals(prev => ({
                                            ...prev,
                                            openDeleteModal: true,
                                            openMainScreen: false,
                                        }));
                                    }}>
                                    <DeleteOutlined className="text-[#18181B] dark:text-[#FFF]" />
                                </div>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => validateWalletAddress()}
                                    disabled={masterState.error || masterState.loading}
                                    sx={{
                                        height: '44px',
                                        borderRadius: '8px',
                                        background: '#FFF',
                                        color: '#18181B',
                                        '&:hover': {
                                            background: '#F0F0F0',
                                        },
                                        '&.Mui-disabled': {
                                            background: '#FFF',
                                            color: '#A1A1AA',
                                            opacity: 0.7,
                                            pointerEvents: 'none',
                                            cursor: 'not-allowed',
                                        },
                                    }}>
                                    {masterState.loading ? 'validating...' : 'save'}
                                </Button>
                            </div>
                        ) : null}
                    </div>
                </TransactionCommonModal>
            ) : null}
            {modals.openConfirmModal && !status.open ? (
                <ActionConfirmModal
                    open={modals.openConfirmModal}
                    heading={'Are you sure?'}
                    subHeading={'Are you sure you want to change the wallet address details?'}
                    onCancel={() =>
                        setModals(prev => ({
                            ...prev,
                            openConfirmModal: false,
                            openMainScreen: true,
                        }))
                    }
                    onConfirm={() => updateAddress()}
                    loading={masterState.loading}
                    body={() => (
                        <div className="self-stretch inline-flex justify-start items-center gap-2">
                            <div className="flex-1 justify-center text-white text-base font-semibold leading-normal">
                                {truncateMiddle(address, 25)}
                            </div>
                            <CopyButton copyValue={address} />
                        </div>
                    )}
                />
            ) : null}

            {modals.openDeleteModal && !status.open ? (
                <ActionConfirmModal
                    open={modals.openDeleteModal}
                    heading={'Delete Address!'}
                    subHeading={'Are you sure you want to delete the address?'}
                    onCancel={() =>
                        setModals(prev => ({
                            ...prev,
                            openDeleteModal: false,
                            openMainScreen: true,
                        }))
                    }
                    onConfirm={() =>
                        deleteAddress(setStatus, () =>
                            setMasterState(prev => ({
                                ...prev,
                                loading: true,
                            })),
                        )
                    }
                    loading={masterState.loading}
                    type={'delete'}
                    actionButtonText="delete"
                    body={() => (
                        <div className="inline-flex flex-col justify-start items-center gap-1">
                            <div className="text-center justify-center text-white text-base font-semibold uppercase leading-normal">
                                {addressNickName}'s Crypto Wallet
                            </div>
                            <div className="text-center justify-center text-zinc-300 text-sm font-medium leading-tight">
                                {truncateMiddle(address, 35)}
                            </div>
                        </div>
                    )}
                />
            ) : null}

            {status.open ? (
                <TransactionStatus
                    onClick={() => {
                        if (onBottomClick) {
                            onBottomClick();
                        }

                        close();
                    }}
                    description={status.message}
                    status={status.type}
                />
            ) : null}
        </>
    );
};

AddNewAddress.propTypes = {
    close: PropTypes.func,
    onBottomClick: PropTypes.func,
    onBack: PropTypes.func,
    back: PropTypes.bool,
    open: PropTypes.bool,
    heading: PropTypes.string,
    bottomText: PropTypes.string,
    getCryptoAddress: PropTypes.func,
};

export default AddNewAddress;
